import { render } from "./CollectionsMenu.vue?vue&type=template&id=9fa02a8e&scoped=true"
import script from "./CollectionsMenu.vue?vue&type=script&lang=js"
export * from "./CollectionsMenu.vue?vue&type=script&lang=js"

import "./CollectionsMenu.vue?vue&type=style&index=0&id=9fa02a8e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fa02a8e"]])

export default __exports__